module.exports = __webpack_public_path__ + "static/media/DEG.f8a279f1.png";